import { useFormat } from 'vivat';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    // status: {
    //   name: 'สถานะ',
    //   width: '8rem',
    //   class: {
    //     text(val: string, row: { item: { [key: string]: any }; index: number }) {
    //       return shipmentStatusClassMap(val);
    //     },
    //   },
    //   filter(val: string, row: { item: { [key: string]: any }; index: number }) {
    //     return translate(val);
    //   },
    // },
    satisfaction: {
      name: 'คะแนน',
      width: '8rem',
    },
    deliveryDate: {
      name: 'วันที่ส่งสินค้า',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    completedDate: {
      name: 'วันที่ส่งสำเร็จ',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    uniqueId: {
      name: 'เลขที่​ใบจัดรถ',
      width: '6rem',
      filter: (val: any, row: any) => row.item.deliveryNote?.uniqueId || row.item.deliveryNoteLogs[0]?.uniqueId || '',
    },
    orderNumber: {
      name: 'เลขที่ใบส่งสินค้า',
      width: '9rem',
    },
    // 'packages.length': {
    //   name: 'รายการสินค้านำส่ง',
    //   width: '8rem',
    //   class: 'text-center',
    // },
    // totalWeight: {
    //   name: 'น้ำหนัก (กก.)',
    //   width: '6rem',
    //   filter: (val: string) => (val as any).toFixed(3),
    //   class: 'text-right',
    // },
    area: {
      name: 'เขตจัดส่ง',
      width: '10rem',
    },
    customerName: {
      name: 'ชื่อผู้รับสินค้า',
      width: '1fr',
      filter: (val: string) => {
        if (val === 'NA') return '';
        return val;
      },
    },
    contactTelephone: {
      name: 'เบอร์ติดต่อ',
      width: '12rem',
      filter: (val: any, row: any) => `${row.item?.address?.telephone || ''}`,
    },
  },
  sortable: [
    'createdAt',
    'driverNumber',
    'orderNumber',
    'orderAmount',
    'weight',
    'path',
    'clientName',
    'tel',
  ],
};
